/**
 * Animate the star glyphs in .c-site-logo--full logos:
 * 1. Fade out current glyphs
 * 2. Collapse glyph containers (words slide to new positions)
 * 3. Expand to new size with new glyphs (words slide out)
 * 4. Fade in new glyphs
 *
 * Same tick as home hero stacked logo (see shuffleHeroStackedLogo).
 */

import {
  LOGO_ANIM_INTERVAL_MS,
  LOGO_ANIM_FADE_MS,
  LOGO_ANIM_SLIDE_MS,
} from "./logo-animation-timings";
import { shuffleHeroStackedLogo } from "./hero-logo";

const GLYPH =
  '<svg class="c-site-logo__glyph" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M53 27C53 38.0457 61.9543 47 73 47H100V53H73C61.9543 53 53 61.9543 53 73V100H47V73C47 61.9543 38.0457 53 27 53H0V47H27C38.0457 47 47 38.0457 47 27V0H53V27Z" fill="currentColor"/></svg>';

function randomCounts(isMini) {
  let n1, n2;
  do {
    n1 = Math.floor(Math.random() * 3);
    n2 = Math.floor(Math.random() * 3);
  } while (n1 + n2 === 0 || (isMini && n1 + n2 > 3));
  return [n1, n2];
}

function shuffleLogo(logo) {  
  const groups = logo.querySelectorAll(".c-site-logo__glyphs");
  if (groups.length < 2) return;

  const prev0 = Number(groups[0].dataset.count || 0);
  const prev1 = Number(groups[1].dataset.count || 0);

  const isMini = logo.classList.contains("c-site-logo--mini");
  let n1, n2;
  do {
    [n1, n2] = randomCounts(isMini);
  } while (n1 === prev0 && n2 === prev1);

  const newCounts = [n1, n2];

  // Step 1: Fade out current glyphs
  groups.forEach((g) => g.classList.add("is-fading"));

  setTimeout(() => {
    // Step 2: Collapse — lock current widths first, then set to 0
    groups.forEach((g) => {
      const currentWidth = g.scrollWidth;
      g.style.width = currentWidth + "px";
    });

    // Force reflow so the explicit width is applied before we animate to 0
    void groups[0].offsetWidth;

    groups.forEach((g, i) => {
      // Replace content while invisible
      g.innerHTML = GLYPH.repeat(newCounts[i]);
      g.dataset.count = newCounts[i];
      // Collapse to 0
      g.style.width = "0px";
    });

    setTimeout(() => {
      // Step 3: Expand to new natural width
      groups.forEach((g) => {
        // Temporarily remove transition to measure natural width
        g.style.transition = "none";
        g.style.width = "auto";
        const naturalWidth = g.scrollWidth;
        g.style.width = "0px";
        // Restore transition
        void g.offsetWidth;
        g.style.transition = "";
        // Animate to natural width
        g.style.width = naturalWidth + "px";
      });

      setTimeout(() => {
        // Step 4: Fade in + clean up
        groups.forEach((g) => {
          g.classList.remove("is-fading");
          // Remove explicit width so it stays flexible
          g.style.width = "";
        });
      }, LOGO_ANIM_SLIDE_MS);
    }, LOGO_ANIM_SLIDE_MS);
  }, LOGO_ANIM_FADE_MS);
}

export function initLogoShuffle() {
  const logos = Array.from(
    document.querySelectorAll(
      ".c-site-logo--full:not(.c-site-logo--footer), .c-site-logo--mini"
    )
  );

  if (logos.length > 0) {
    // Set initial explicit widths for glyph groups so transitions work from the start
    logos.forEach((logo) => {
      logo.querySelectorAll(".c-site-logo__glyphs").forEach((g) => {
        const w = g.scrollWidth;
        g.style.width = w + "px";
        requestAnimationFrame(() => {
          g.style.width = "";
        });
      });
    });
  }

  setInterval(() => {
    logos.forEach((logo) => shuffleLogo(logo));
    shuffleHeroStackedLogo();
  }, LOGO_ANIM_INTERVAL_MS);
}
